import { isNotNullish } from './type-utils';

export function removeNullishValues(obj: Record<string, unknown>): Record<string, unknown> {
   
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => isNotNullish(value)));
}
